<template>
  <a-space>
    <select-day-vue
      :defaultVal="reqPayload.localDate"
      @userDelectDay="selectTime($event, 'localDate')"
    />

    <select-range-day @userPickRangeTime="userPickRangeTime">
    </select-range-day>

    <a-input
      v-model:value="reqPayload.materialBatchNumber"
      @change="handleSearch"
      placeholder="输入物料批号"
      allowClear
    ></a-input>

    <a-select
      v-model:value="reqPayload.materialType"
      placeholder="选择物料类型"
      allowClear
      @change="handleSearch"
    >
      <a-select-option value="1">电子物料</a-select-option>
      <a-select-option value="2">结构物料</a-select-option>
      <a-select-option value="3">光学物料</a-select-option>
    </a-select>

    <a-select
      v-model:value="reqPayload.incomingMaterialProperties"
      placeholder="来料属性"
      allowClear
      @change="handleSearch"
    >
      <a-select-option value="0">正常来料</a-select-option>
      <a-select-option value="1">一次换货/返修</a-select-option>
      <a-select-option value="2">二次换货/返修</a-select-option>
      <a-select-option value="3">三次换货/返修</a-select-option>
      <a-select-option value="4">四次换货/返修</a-select-option>
      <a-select-option value="5">五次换货/返修</a-select-option>
      <a-select-option value="6">六次换货/返修</a-select-option>
      <a-select-option value="7">七次换货/返修</a-select-option>
      <a-select-option value="8">八次换货/返修</a-select-option>
      <a-select-option value="9">九次换货/返修</a-select-option>
    </a-select>
  </a-space>
</template>

<script>
import { defineComponent, reactive } from "vue";
import selectRangeDay from "@/components/daypicker/range.vue";
import selectDayVue from "@/views/repairprogress/compoments/selectDay.vue";
import { getlocalDate } from "@/views/productDaily/components/quality/serve/data";

export default defineComponent({
  components: { selectDayVue, selectRangeDay },
  setup(props, context) {
    const reqPayload = reactive({
      startTime: null,
      endTime: null,
      materialType: null,
      materialBatchNumber: null,
      incomingMaterialProperties: null,
      inspectionMethod: null,
      inspector: null,
      localDate: null,
    });

    const handleSearch = () => {
      context.emit("emitSearch", reqPayload);
    };

    const selectTime = (e, type) => {
      reqPayload[type] = e;
      handleSearch();
    };

    const userPickRangeTime = (e) => {
      const [startDate, endDate] = e;
      if (startDate !== "" && endDate !== "") {
        reqPayload.startDate = startDate;
        reqPayload.endDate = endDate;
      } else {
        reqPayload.startDate = null;
        reqPayload.endDate = null;
      }
      handleSearch();
    };

    const init = () => {
      reqPayload.localDate = getlocalDate();
      handleSearch();
    };

    init();

    return {
      reqPayload,
      selectTime,
      userPickRangeTime,
      handleSearch,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
